import { styles } from "@routes/InvestmentPriorityRoute/styles";

const STROKE = "#FFAC7D";
const FILL = "#FFAC7D";

export const BalancedChart = () => {
  return (
    <svg
      width="157"
      height="44"
      viewBox="0 0 157 44"
      fill="none"
      aria-hidden="true"
      style={styles.chart}
    >
      <defs>
        <linearGradient
          id="bal-mask-grad"
          x1="78.5"
          y1="31.5"
          x2="0"
          y2="31.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={FILL} />
          <stop stopColor={FILL} offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="bal-fill-grad"
          x1="79"
          y1="-16.4038"
          x2="79"
          y2="45.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={STROKE} />
          <stop offset="1" stopColor={STROKE} stopOpacity="0" />
        </linearGradient>
        <mask id="bal-mask" maskUnits="userSpaceOnUse" x="0" y="0" width="157" height="44">
          <path d="M0 0H157V34C157 39.5228 152.523 44 147 44H0V0Z" fill="url(#bal-mask-grad)" />
        </mask>
      </defs>
      <g mask="url(#bal-mask)">
        <path
          d="M0 30.7671C2.79422 30.7671 3.70444 28.9455 5.06977 28.9455C6.4351 28.9455 9.40531 31.0393 11.9024 31.0393C13.1626 31.0393 14.6271 34.2481 17.8129 34.2481C20.5435 34.2481 22.1231 30.1594 23.8048 30.1594C25.4865 30.1594 27.4539 32.107 29.9151 32.107C32.3764 32.107 34.0728 30.5032 35.7073 30.5032C37.3417 30.5032 38.7479 25.8826 41.5188 25.8826C44.2897 25.8826 47.3692 28.5782 48.5199 28.5782C49.6706 28.5782 52.6413 21.7581 54.7666 22.5714C58.5 24 62 16.5838 64.5 17.7919C67 19 69.0684 12.7604 71.5511 12.7604C74.0338 12.7604 75.6118 18.7919 77.8874 18.7919C80.1629 18.7919 81 16.5782 83.3169 16.5983C85.6339 16.6184 86.2054 13.5911 88.6455 13.5911C91.0856 13.5911 92.4155 20.2943 95.2194 20.2943C97.9614 20.2943 97.9591 12.5581 100.677 12.5581C102.965 12.5581 102.918 16.5408 105.301 16.5408C107.684 16.5408 108.585 23.1821 111.192 23.1821C113.798 23.1821 114 16.5 117.161 15.8633C118.938 15.5054 121.625 10.0976 123.9 10.0976C126.176 10.0976 127.662 16.0393 129.153 16.0393C129.963 16.0393 134.257 5.28867 136.415 7.24645C138.574 9.20423 139.515 12.2752 140.919 12.2752C142.322 12.2752 144.186 7.12182 145.913 7.12182C147.639 7.12182 147.5 10.5634 149.551 10.5634C151.602 10.5634 152.667 7.15193 153.807 4.85775C154.946 2.56357 158 2 158 2"
          stroke={STROKE}
          strokeWidth="2"
        />
        <path
          d="M71.5511 12.7604C69.0684 12.7604 67 19 64.5 17.7919C62 16.5838 58.5 24 54.7666 22.5714C52.6413 21.7581 49.6706 28.5782 48.5199 28.5782C47.3692 28.5782 44.2897 25.8826 41.5188 25.8826C38.7479 25.8826 37.3417 30.5032 35.7073 30.5032C34.0728 30.5032 32.3764 32.107 29.9151 32.107C27.4539 32.107 25.4865 30.1594 23.8048 30.1594C22.1231 30.1594 20.5435 34.2481 17.8129 34.2481C14.6271 34.2481 13.1626 31.0393 11.9024 31.0393C9.40531 31.0393 6.4351 28.9455 5.06977 28.9455C3.70444 28.9455 2.79422 30.7671 0 30.7671V45.5H158V2C158 2 154.946 2.56357 153.807 4.85775C152.667 7.15193 151.602 10.5634 149.551 10.5634C147.5 10.5634 147.639 7.12182 145.913 7.12182C144.186 7.12182 142.322 12.2752 140.919 12.2752C139.515 12.2752 138.574 9.20423 136.415 7.24645C134.257 5.28867 129.963 16.0393 129.153 16.0393C127.662 16.0393 126.176 10.0976 123.9 10.0976C121.625 10.0976 118.938 15.5054 117.161 15.8633C114 16.5 113.798 23.1821 111.192 23.1821C108.585 23.1821 107.684 16.5408 105.301 16.5408C102.918 16.5408 102.965 12.5581 100.677 12.5581C97.9591 12.5581 97.9614 20.2943 95.2194 20.2943C92.4155 20.2943 91.0856 13.5911 88.6455 13.5911C86.2054 13.5911 85.6339 16.6184 83.3169 16.5983C81 16.5782 80.1629 18.7919 77.8874 18.7919C75.6118 18.7919 74.0338 12.7604 71.5511 12.7604Z"
          fill="url(#bal-fill-grad)"
        />
      </g>
    </svg>
  );
};
